import animation, { fadeIn } from '@helpers/animation';
import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { headerOverlap } from '@helpers/utils';
import BreadcrumbStyles from '@stories/Components/Breadcrumb/Breadcrumb.styles';
import CarouselControlsStyles from '@stories/Components/CarouselControls/CarouselControls.styles';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import SiteWideStyles from '@stories/Components/Global/SiteWide/SiteWide.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { m } from 'framer-motion';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  ${headerOverlap};

  position: relative;
  display: grid;
  min-height: 80vh;
`;
const Inner = styled(m.div) ``;
const MediaWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
  width: 100%;
  z-index: 1;
  background-color: ${brand.black};
`;
const Image = styled(m.img) `
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  width: 100%;
  background-color: ${brand.black};
`;
const Player = styled(m.div) `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;

  ${({ isExternal }) => isExternal &&
    css `
      width: 100vw;
      height: 100vh;
    `};

  video,
  iframe {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    height: 100%;
    width: 100%;
    pointer-events: none;
  }

  video {
    object-fit: cover;
    object-position: center center;
  }

  iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100vw;
    height: 100vh;
    transform: translate(-50%, -50%);

    @media (min-aspect-ratio: 16/9) {
      height: 56.25vw;
    }

    @media (max-aspect-ratio: 16/9) {
      width: 177.78vh;
    }
  }
`;
const Overlay = styled(m.div) `
  position: absolute;
  top: 0;
  left: 0;
  background: ${rgba(brand.black, 0.4)};
  height: 100%;
  width: 100%;
  z-index: 2;
`;
const ContentWrapper = styled(SiteWide) `
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  text-align: center;
  z-index: 3;
`;
const ContentWrapperInner = styled(m.div) `
  position: relative;
`;
const BreadcrumbWrapper = styled(m.div) `
  display: flex;
  justify-content: center;

  ${BreadcrumbStyles.Container} {
  }
`;
const Title = styled(m.h1) `
  position: relative;
  display: block;
  ${fonts.gotham.regular};
  font-size: 48px;
  letter-spacing: 0.05em;
  line-height: 60px;
  margin: 0;
  max-width: 1080px;
  text-transform: uppercase;

  @media ${from(Device.Tablet)} {
    font-size: 48px;
    line-height: 60px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 70px;
    line-height: 70px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 100px;
    line-height: 133px;
  }
`;
const Line = styled(m.span) `
  position: absolute;
  bottom: 0;
  left: 50%;
  display: block;
  background: ${cssVar('accentColor')};
  height: 3px;
  transform: translateX(-50%);
  transform-origin: center center;
  width: 128px;

  @media ${from(Device.TabletLarge)} {
    width: 176px;
  }
`;
const Controls = styled.div `
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 150px;
  z-index: 5;
  background: linear-gradient(to bottom, transparent, ${rgba(brand.black, 0.75)});

  ${SiteWideStyles.Container} {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    height: 100%;
    padding-bottom: 30px;
  }

  ${CarouselControlsStyles.Container} {
    height: 40px;
  }

  @media ${until(Device.Tablet)} {
    ${CarouselControlsStyles.SlideButton} {
      display: none;
    }
  }

  @media ${from(Device.TabletLarge)} {
    opacity: 0;

    ${({ isActive, delay }) => isActive &&
    delay &&
    css `
        ${fadeIn(isActive, 375, delay, animation.easeInOutCubic)};
      `}
  }
`;
export default {
    BreadcrumbWrapper,
    Container,
    ContentWrapper,
    ContentWrapperInner,
    Controls,
    Image,
    MediaWrapper,
    Inner,
    Line,
    Player,
    Overlay,
    Title,
};
